import RequestTemplate from 'components/templates/RequestTemplate'
import { PAGE_PATH } from 'constants/pagePath'
import React from 'react'
import styled from 'styled-components'
import Text from 'components/elements/texts/Text'
import { PageMessage } from 'constants/pageMessage'
import { useEditQnState, useProgressPoint } from '../../utils/commonHooks'
import { VEHICLE_STATE } from 'constants/qnState'

/**
 * SAFIC-01: 宿・移サービス案内画面
 */
const ServiceInformation: React.FC = () => {
  const [editingItem] = useEditQnState()

  const troubleScreenPath: Record<string, string> = {
    [VEHICLE_STATE.ACCIDENT]: PAGE_PATH.ACCIDENT,
    [VEHICLE_STATE.EMPTY_FUEL]: PAGE_PATH.EMPTY_FUEL,
    [VEHICLE_STATE.ENGINE_TROUBLE]: PAGE_PATH.ENGINE_TROUBLE,
    [VEHICLE_STATE.FALLING_WHEEL]: PAGE_PATH.FALLING_WHEEL,
    [VEHICLE_STATE.FLAT_TIRE]: PAGE_PATH.FLAT_TIRE,
    [VEHICLE_STATE.LOSS_KEY]: PAGE_PATH.LOSS_KEY,
    [VEHICLE_STATE.OTHERS]: PAGE_PATH.OTHERS,
  }
  return (
    <RequestTemplate
      title={PageMessage['serviceInformation.title']}
      showContact
      progress={useProgressPoint()}
      content={
        <React.Fragment>
          <RootStyled>
            {PageMessage['serviceInformation.description'].map((message, i) => (
              <Text key={i}>{message}</Text>
            ))}
            <MovingCostCompensationArea>
              <Text bold>
                {
                  PageMessage[
                    'serviceInformation.movingCostCompensation.header'
                  ]
                }
              </Text>
              <Text bold decoration="underline">
                {
                  PageMessage[
                    'serviceInformation.movingCostCompensation.transportation'
                  ]
                }
              </Text>
              <Text>
                {
                  PageMessage[
                    'serviceInformation.movingCostCompensation.transportationMaximum'
                  ]
                }
              </Text>
              <Text bold decoration="underline">
                {PageMessage['serviceInformation.movingCostCompensation.taxi']}
              </Text>
              <Text>
                {
                  PageMessage[
                    'serviceInformation.movingCostCompensation.taxiMaximum'
                  ]
                }
              </Text>
              <Comment>
                {PageMessage[
                  'serviceInformation.movingCostCompensation.comment'
                ].map((message, i) => (
                  <Text key={i}>{message}</Text>
                ))}
              </Comment>
            </MovingCostCompensationArea>
            <LodgingExpenseCompensationArea>
              <Text bold>
                {
                  PageMessage[
                    'serviceInformation.lodgingExpenseCompensation.header'
                  ]
                }
              </Text>
              <Text>
                {
                  PageMessage[
                    'serviceInformation.lodgingExpenseCompensation.description'
                  ]
                }
              </Text>
              <Comment>
                {PageMessage[
                  'serviceInformation.lodgingExpenseCompensation.comment'
                ].map((message, i) => (
                  <Text key={i}>{message}</Text>
                ))}
              </Comment>
            </LodgingExpenseCompensationArea>
          </RootStyled>
        </React.Fragment>
      }
      forwardTo={PAGE_PATH.CONTRACT_INFORMATION}
      backTo={
        troubleScreenPath[editingItem.vehicleState || PAGE_PATH.VEHICLE_STATE]
      }
      showBack
      notClearEditingItem
    />
  )
}

const RootStyled = styled.div`
  padding: 10px 16px;
  background: var(--color-content-background);
`

const MovingCostCompensationArea = styled.div`
  margin-top: 26px;
`

const Comment = styled.div`
  margin-top: 29px;
`

const LodgingExpenseCompensationArea = styled.div`
  margin-top: 31px;
`

export default ServiceInformation
